// extracted by mini-css-extract-plugin
export default {"root":"SearchPanelHeader__root--wbI4s","isHidden":"SearchPanelHeader__isHidden--u_Vbb","text":"SearchPanelHeader__text--y28As","button":"SearchPanelHeader__button--UlXSL"};